const quQuestionnaire_reports = {
  permissionSource: 'api::questionnaire-report.questionnaire-report',
  creationTitle: 'Create Questionnaire Report',
  creationEndPoint: '/questionnaire-reports',
  detailTitle: 'Questionnaire Report: :code',
  detailEndPoint: '/questionnaire-reports/:id?populate=*',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Title',
          value: 'title',
          tag: 'input',
          type: 'text',
          placeholder: 'Questionnaire Report Title',
          required: true,
        },
        {
          label: 'Report Datetime',
          value: 'report_time',
          tag: 'datetime-picker',
        },
      ],
    },
    {
      label: 'Description',
      value: 'description',
      tag: 'richTextarea',
      placeholder: 'Description',
    },
    {
      label: 'Content',
      value: 'content',
      tag: 'richTextarea',
      placeholder: 'Questionnaire Report Content',
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Format',
          value: 'format',
          tag: 'input',
          type: 'text',
        },
        {
          label: 'Total responses',
          value: 'total_responses',
          tag: 'input',
          type: 'number',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Completion rate',
          value: 'completion_rate',
          tag: 'input',
          type: 'number',
        },
        {
          label: 'Average score',
          value: 'average_score',
          tag: 'input',
          type: 'number',
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default quQuestionnaire_reports
